import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 下单按钮 */
const PlaceOrderButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

PlaceOrderButton.defaultProps = {
  icon: ICON_COLLECTION.PLACE_ORDER,
  text: '下单',
};

export default PlaceOrderButton;
